// components/widgets/Identity/FutureYou/CompletionPages/FutureFinalResult.jsx
import React from "react";
import FutureIdentityCard from "../FutureIdentityCard";

const FutureFinalResult = ({ futureData, userName, profileImage, onComplete }) => {
  return (
    <div className="fixed inset-0 z-[9998] flex mt-12 items-center justify-center p-4 md:p-8 bg-white">
      <div className="w-full max-w-[429px] min-h-[712px] flex flex-col items-center">
        <div className="mb-8 w-full">
          <FutureIdentityCard
            futureData={futureData}
            userName={userName}
            profileImage={profileImage}
          />
        </div>

        <button
          onClick={onComplete}
          className="inline-flex items-center gap-2 px-8 py-3 bg-[#54B0AF] text-white font-gotham font-semibold rounded-full shadow-md hover:bg-teal-600 hover:shadow-lg transition-all"
        >
          Next: Strength Agent
          <svg
            className="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default FutureFinalResult;
